import { GoodDto } from '@rtls/core/models/goods/good-dto.model';
import { randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const goodFactory = Factory.makeFactory<GoodDto>({
	uuid: Factory.each(() => randomWord()),
	name: randomName(),
	names: {
		en: randomName(),
		fr: randomName(),
	},
});
